import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { closePopup } from '../../actions/uiActions';
import CloseIcon from '@mui/icons-material/Close';

class ContactInfoPopup extends React.Component {

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                Contact Jav Rodriguez
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="requiredContact">
                        <div className="myInputOut">
                            <p>Sales: (212) 462-4900 | info@interactiveedge.com</p>
                            <p>Support: (914) 775-7341 | support@interactiveedge.com</p>
                            <p>Address: 1345 Avenue of the Americas New York, NY 10105</p>
                        </div>
                        <div className="bigButtonOut">
                            <button className="btn" onClick={this.handleClick}>
                                Close
                            </button>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfoPopup)